import { render, staticRenderFns } from "./AppointmentsRecord.vue?vue&type=template&id=585e0730&scoped=true"
import script from "./AppointmentsRecord.vue?vue&type=script&lang=js"
export * from "./AppointmentsRecord.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsRecord.vue?vue&type=style&index=0&id=585e0730&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585e0730",
  null
  
)

export default component.exports